var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSccCritical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 2,
    fill: "#C5221F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 13.1579L14.3333 2.96057L13.1667 10.1974H18.8333L9.33332 20.7237L11.6667 13.1579H6.66666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSccCritical);
export default __webpack_public_path__ + "static/media/scc_Critical.6310d8ffda19c7c6feee0afb9f702de5.svg";
export { ForwardRef as ReactComponent };